module.exports = __webpack_public_path__ + "img/CMI_cover.6b7ac026.jpg";